module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.1f9fa2f.woff";